import { CircularProgress as CPMaterialUI } from "@material-ui/core";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useStyles = makeThemedStyles("CircularProgress", (theme) => ({
  root: {
    width: "100%",
    display: "flex",
    padding: "40px",
    justifyContent: "center",
  },
}));

const CircularProgress = (props: {}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <CPMaterialUI />
    </div>
  );
};

export default CircularProgress;
